import { create } from "zustand";

export const useStoreModal = create((set, get) => ({
  modals: {},

  openModal: (id, props = {}) =>
    set((state) => ({
      modals: {
        ...state.modals,
        [id]: { id, isOpen: true, props },
      },
    })),

  closeModal: (id) =>
    set((state) => {
      const modal = state.modals[id];
      if (!modal) return {};
      
      // Update isOpen immediately
      const updatedModals = {
        ...state.modals,
        [id]: { ...modal, isOpen: false }
      };
      
      // Remove props after 300ms timeout
      setTimeout(() => {
        set((state) => ({
          modals: {
            ...state.modals,
            [id]: { ...state.modals[id], props: null }
          }
        }));
      }, 300);
      
      return {
        modals: updatedModals
      };
    }),

  toggleModal: (id) =>
    set((state) => {
      const modal = state.modals[id];
      if (!modal) return {};
      
      const isClosing = modal.isOpen;
      
      // Update isOpen immediately
      const updatedModals = {
        ...state.modals,
        [id]: { ...modal, isOpen: !modal.isOpen }
      };
      
      // Remove props after 300ms timeout if closing
      if (isClosing) {
        setTimeout(() => {
          set((state) => ({
            modals: {
              ...state.modals,
              [id]: { ...state.modals[id], props: null }
            }
          }));
        }, 300);
      }
      
      return {
        modals: updatedModals
      };
    }),

  getModal: (id) => get().modals[id],
}));
